export const createProfileAPIConfig = () => ({
    url: '/api/user-profile',
    method: 'POST',
});

export const getSignUpDataAPIConfig = () => ({
    url: '/api/user-profile/sign-up',
    method: 'GET',
});

export const getUserStatusAPIConfig = () => ({
    url: '/api/users/me/status',
    method: 'GET',
});

export const updateUserProfileSignUpDataAPIConfig = userProfile => ({
    url: '/api/user-profile/me',
    method: 'PATCH',
    data: {
        full_name: userProfile.fullName,
        phone: userProfile.phone,
        is_sign_up_data_complete: true,
    },
});

export const updateCompanySignUpDataAPIConfig = company => ({
    url: '/api/users/me/companies/',
    method: 'PATCH',
    data: {
        company_name: company.companyName,
        company_size: company.companySize,
        role: company.role,
        section: company.section,
        is_sign_up_data_complete: true,
    },
});
